import React from 'react';
import PropTypes from 'prop-types';

// Common Components
import SimpleTasksHeader from './SimpleTasksHeader';
import TasksList from './SimpleTasksList';
import SimpleTasksDropdown from './SimpleTasksDropdown';

// Individual Pages
import GetUser from './simpleTasks/GetUser';
import GetPost from './simpleTasks/GetPost';
// import GetStream from './simpleTasks/GetStream';
import UploadProfileImage from './simpleTasks/UploadProfileImage';
import UploadVideo from './simpleTasks/UploadVideo';
import PreregisterUser from './simpleTasks/PreregisterUser';
import UpdateUser from './simpleTasks/UpdateUser';
import SharePost from './simpleTasks/SharePost';
import ManageTargets from './simpleTasks/ManageTargets';

class SimpleTasks extends React.PureComponent {

	componentDidMount() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	componentDidUpdate() {
		if (window.Prism) { window.Prism.highlightAll() }
	}

	render() {
		const { task } = this.props.match.params;
		let jsx = null;

		switch (task) {
			case 'get-user': jsx = (<GetUser />); break;
			case 'get-post': jsx = (<GetPost />); break;
			// case 'get-stream': jsx = (<GetStream />); break;
			case 'upload-profile-image': jsx = (<UploadProfileImage />); break;
			case 'upload-video': jsx = (<UploadVideo />); break;
			case 'preregister-user': jsx = (<PreregisterUser />); break;
			case 'update-user': jsx = (<UpdateUser />); break;
			case 'share-post': jsx = (<SharePost />); break;
			case 'manage-targets': jsx = (<ManageTargets />); break;
			default: jsx = (<TasksList />); break;
		}
		return (
			<div>
				<div className="simple-tasks">
					<SimpleTasksHeader />
					<div className='responsive-small'>
						<SimpleTasksDropdown />
					</div>
					{jsx}
				</div>
			</div>
		);
	}
}

SimpleTasks.propTypes = {
	match: PropTypes.object
};

export default SimpleTasks;


// WEBPACK FOOTER //
// ./src/components/getting-started/SimpleTasks.js